import {ActionCreatorDefinition, createAction} from "redux-ts";
import {PortfolioType} from "enum/PortfolioType";
import {TradeColumn} from "enum/TradeColumn";
import {AccountLog} from "protocol/account/AccountLog";
import {TSMap} from "typescript-map";
import {PortfolioTableState} from "core/redux/portfolio/PortfolioReduxState";

export const SetPortfolioTabType: string =  "SetPortfolioTab";
export const SetPortfolioFilterCounterType: string =  "SetPortfolioFilterCounter";
export const SetPortfolioTablesType: string =  "SetPortfolioTables";
export const SetPortfolioTradeColumnType: string =  "SetPortfolioTradeColumn";
export const TogglePortfolioColumnSortType: string =  "TogglePortfolioColumnSort";
export const SetAccountLogsType: string =  "SetAccountLogs";
export const SetAccountLogsPendingType: string =  "SetAccountLogsPending";
export const FetchAccountEquityLogsType: string =  "FetchAccountEquityLogs";
export const SetAccountEquityLogsType: string =  "SetAccountEquityLogs";

export interface SetPortfolioTabPayload {

    portfolioType: PortfolioType;
}

export interface SetPortfolioFilterCounterPayload {

    portfolioType: PortfolioType;
    value: number;
}

export interface SetPortfolioTablesPayload {

    tables?: TSMap<PortfolioType, PortfolioTableState>;
}

export interface SetPortfolioTradeColumnPayload {

    tradeColumn: TradeColumn;
}

export interface TogglePortfolioColumnSortPayload {

    tradeColumn: TradeColumn;
}

export interface SetAccountLogsPayload {

    logs: AccountLog[];
}

export interface SetAccountLogsPendingPayload {

    pending: boolean;
}

export interface FetchAccountEquityLogsPayload {

    from: Date;
    to: Date;
}

export interface SetAccountEquityLogsPayload {

    logs: AccountLog[];
}

export const SetPortfolioTab: ActionCreatorDefinition<SetPortfolioTabPayload, any> = createAction<SetPortfolioTabPayload>(SetPortfolioTabType);
export const SetPortfolioFilterCounter: ActionCreatorDefinition<SetPortfolioFilterCounterPayload, any> = createAction<SetPortfolioFilterCounterPayload>(SetPortfolioFilterCounterType);
export const SetPortfolioTables: ActionCreatorDefinition<SetPortfolioTablesPayload, any> = createAction<SetPortfolioTablesPayload>(SetPortfolioTablesType);
export const SetPortfolioTradeColumn: ActionCreatorDefinition<SetPortfolioTradeColumnPayload, any> = createAction<SetPortfolioTradeColumnPayload>(SetPortfolioTradeColumnType);
export const TogglePortfolioColumnSort: ActionCreatorDefinition<TogglePortfolioColumnSortPayload, any> = createAction<TogglePortfolioColumnSortPayload>(TogglePortfolioColumnSortType);
export const SetAccountLogs: ActionCreatorDefinition<SetAccountLogsPayload, any> = createAction<SetAccountLogsPayload>(SetAccountLogsType);
export const SetAccountLogsPending: ActionCreatorDefinition<SetAccountLogsPendingPayload, any> = createAction<SetAccountLogsPendingPayload>(SetAccountLogsPendingType);
export const FetchAccountEquityLogs: ActionCreatorDefinition<FetchAccountEquityLogsPayload, any> = createAction<FetchAccountEquityLogsPayload>(FetchAccountEquityLogsType);
export const SetAccountEquityLogs: ActionCreatorDefinition<SetAccountEquityLogsPayload, any> = createAction<SetAccountEquityLogsPayload>(SetAccountEquityLogsType);
